export const svgToPng = (svgElement:SVGAElement):Promise<string> => {
  return new Promise((resolve, reject) => {
    // 1. Get the SVG's dimensions
    const { width, height } = svgElement.getBBox();

    // 2. Serialize the SVG to an XML string
    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svgElement);

    // 3. Create a Blob from the SVG string
    // A Blob is a file-like object of immutable, raw data.
    const svgBlob = new Blob([svgString], { type: "image/svg+xml;charset=utf-t" });

    // 4. Create a URL for the Blob
    const url = URL.createObjectURL(svgBlob);

    // 5. Create an Image object to load the SVG
    const img = new Image();
    img.width = width;
    img.height = height;

    img.onload = () => {
      // 6. Create a canvas element
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      if (ctx == null) {
        throw new Error("fuck")
      }
      // 7. Draw the image onto the canvas
      ctx.drawImage(img, 0, 0);

      // 8. Get the PNG data URL
      const pngDataUrl = canvas.toDataURL("image/png");

      // 9. Clean up the Blob URL
      URL.revokeObjectURL(url);

      // 10. Resolve the promise with the data URL
      resolve(pngDataUrl);
    };

    img.onerror = (err) => {
      // Clean up and reject the promise
      URL.revokeObjectURL(url);
      reject(err);
    };
    
    // Start loading the image
    img.src = url;
  });
}
